import React from "react";
import {
  Box,
  Button,
  Flex,
  Grid,
  Tag,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { formatDateTime } from "utils/dateUtils/dateUtils";

interface CardProps {
  data: any[];
  selectedValues: string[];
  canRaiseIssue: boolean;
  canCancelOrder: boolean;
  setOpenCancelModal: (value: React.SetStateAction<boolean>) => void;
  setSelectedValues: (value: React.SetStateAction<string[]>) => void;
  handleTransactionId: any;
}

export default function OrderCard({
  data,
  selectedValues,
  canRaiseIssue,
  canCancelOrder,
  setOpenCancelModal,
  setSelectedValues,
  handleTransactionId,
}: CardProps) {
  return (
    <>
      <Grid templateColumns="1fr" gap={4}>
        {data?.map((txn: any) => {
          const providers = txn?.orders?.map((o: any) => o.providerName) || [];
          const providerLabel =
            [...new Set(providers)].length > 1
              ? "Multiple"
              : providers[0] || "N/A";

          const orderTransactionIds =
            [...new Set(txn?.orders?.map((o: any) => o?.transaction_id))].filter(
              Boolean
            ) || [];

          return (
            <Box key={txn._id} p={4} shadow="base" borderRadius="lg" bg="white">
              <Flex justify="space-between" mb={2}>
                <Tooltip label={txn?._id}>
                  <Text fontWeight="bold" color="teal.500" isTruncated={true} w={"10rem"}>
                    Transaction ID: {txn?._id}
                  </Text>
                </Tooltip>
              </Flex>

              {orderTransactionIds.length > 0 && (
                <Flex justify="space-between" mb={2} direction="column">
                  <Text fontWeight="semibold">Order Transaction ID(s):</Text>
                  {orderTransactionIds.map((id: any, i: number) => (
                    <Tooltip key={i} label={id}>
                      <Text isTruncated maxW="14rem">
                        {id}
                      </Text>
                    </Tooltip>
                  ))}
                </Flex>
              )}

              <Flex justify="space-between" mb={2}>
                <Text>User: {txn?.user?.name || txn?.billingDetails?.name || "N/A"}</Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>Phone: {txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A"}</Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>
                  Stations: {txn?.startStation || "N/A"} → {txn?.destinationStation || "N/A"}
                </Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>Providers: {providerLabel}</Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>No of Tickets: {txn?.ticketCount || 0}</Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>Total Fare: ₹ {txn?.totalPrice || 0}</Text>
              </Flex>

              <Flex justify="space-between" mb={2}>
                <Text>Order Date: {formatDateTime(txn?.createdAt, "DD-MM-YYYY")}</Text>
              </Flex>

              <Flex justifyContent="flex-end" alignItems="center">
                <Tag
                  size={"sm"}
                  mt={2}
                  colorScheme={
                    txn?.status === "SUCCESSFUL"
                      ? "green"
                      : txn?.status === "REFUNDED"
                        ? "green"
                        : txn?.status === "PAYMENT_VERIFIED"
                          ? "green"
                          : txn?.status === "PAYMENT_FAILED"
                            ? "red"
                            : txn?.status === "CANCELLED"
                              ? "red"
                              : txn?.status === "PAYMENT_INITIATED"
                                ? "orange"
                                : txn?.status === "CANCEL_INITIATED"
                                  ? "orange"
                                  : "blue"
                  }
                  ml={2}
                  py={1}
                  px={2}
                  borderRadius="md"
                >
                  {txn?.status}
                </Tag>

                {canRaiseIssue && (
                  <Button
                    mt={2}
                    colorScheme="teal"
                    size="xs"
                    onClick={() => handleTransactionId(txn)}
                    ml={2}
                  >
                    Issue
                  </Button>
                )}

                {canCancelOrder && txn?.status === "ACTIVE" && (
                  <Button
                    variant="outline"
                    colorScheme="red"
                    size="xs"
                    ml={2}
                    mt={2}
                    isDisabled={selectedValues.length > 0}
                    onClick={() => {
                      setOpenCancelModal(true);
                      setSelectedValues((prevSelectedValues: string[]) => [
                        ...prevSelectedValues,
                        txn?._id,
                      ]);
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Flex>
            </Box>
          );
        })}
      </Grid>
    </>
  );
}